<div class="profile-activity-sidebar">
  <div class="profile-user-details wpee-block">
    <div class="wpee-block-header">
      <h4 class="wpee-block-title">User Details</h4>
    </div>
    <div class="wpee-block-footer">
      <a class="view-detail-link" (click)="openEdit()" *ngIf="is_myProfile && !loader">Edit Profile </a>
      <a class="view-detail-link" (click)="openViewDetails()" *ngIf="!is_myProfile && !loader">View Details</a>
      <div [ngClass]="{ 'shine': loader }">

      </div>
    </div>
    <div class="wpee-user-details-inner wpee-block-content">
      <ul class="profile-detail-list" *ngIf="!loader">
        <li class="profile-gender">
          <span class="gender-title">I am:</span>
          {{userDetails[0].gender}}
        </li>
        <li class="profile-seeking" *ngIf="userDetails[0].seeking">
          <span class="seeking-title">Seeking a:</span>
          {{userDetails[0].seeking}}
        </li>
        <li class="profile-age" *ngIf="userDetails[0].age">
          <span class="age-title">Age:</span>
          {{userDetails[0].age}}
        </li>
        <li class="profile-country" *ngIf="userDetails[0].contry">
          <span class="country-title">Country:</span>
          {{userDetails[0].contry}}
        </li>
      </ul>
      <div [ngClass]="{ 'shine': loader }">
      </div>
    </div>
  </div>
</div>